// extracted by mini-css-extract-plugin
export default {"root":"NoData_root__sKgPJ","img":"NoData_img__akVJ-","textWrapper":"NoData_textWrapper__O2iSF","title":"NoData_title__W+N4Q"};